/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
*/

import gql from "graphql-tag";

export const GET_INACTIVE_BOXES = gql`
  query GetInactiveBoxes($filter: InActiveBoxFilterInput, $options: GetManyOptions) {
    getInactiveBoxes(filter: $filter, options: $options) {
      content {
        _id
        amountPaid
        costumeID
        totalAmount
        user {
          fullName
          email
          gender
          creatorUser {
            email
            fullName
            id
          }
        }
        paymentStats
        presentation {
          id
          name
          status
          year
        }
        section {
          costumeTypes {
            name
            id
          }
          id
          name
          maxInvites
        }
        isVIP
        items {
          costumeAttribute {
            id
            name
          }
        }
        referal {
          inviteType
          partition
          sectionOptType
          id
        }
        inactive {
          date
          reason
          type
          user {
            email
            fullName
          }
        }
      }
      count
      limit
      skip
      sort {
        field
        order
      }
    }
  }
`;
